export const FONT_FAMILY_BASE = 'Lato';
export const FONT_WEIGHT_BASE = 400;
export const FONT_FAMILY_BOLD = 'Lato Bold';
export const FONT_WEIGHT_BOLD = 700;
